import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "370px",
    maxWidth: "450px",
    overflowY: "scroll",
    "& .MuiFormHelperText-root": {
      color: "#ffcc00",
    },
  },
  card: {
    borderRadius: "10px",
    color: theme.palette.text.tertiary,
  },
  cardContent: {
    backgroundColor: theme.palette.primary.main,
    padding: "30px",
    position: "relative",
    minHeight: "300px",
  },
  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "3px",
    borderRadius: "10px",
  },

  cardContentDiv4: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    height: "60px",
    width: "100%",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
  },

  autoComplete: {
    width: "100%",
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "5px",
    "& .MuiInput-underline:before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline.Mui-focused:after": {
      borderBottom: "none !important",
    },
    "& .MuiInput-underline.Mui-focused:before": {
      borderBottom: "none !important",
    },
  },
  done: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      background: theme.palette.secondary.light,
    },
  },
  cardAction: {
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    marginTop: "5px",
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  addNewStatusButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
  },
  defaultButton: {
    color: theme.palette.text.tertiary,
    minWidth: 0,
    padding: "0px",
  },
  selectedButton: {
    color: theme.palette.text.primary,
    minWidth: 0,
    padding: "0px",
    borderBottom: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "0px",
  },
}));

export default useStyles;
